import "pixi";
import "phaser";

import * as level from "./states/level";
import * as i18n from "./i18n";

export class Dashboard {
    game: Phaser.Game;
    group: Phaser.Group;

    undoButton: DashButton;
    restartButton: DashButton;
    menuButton: DashButton;

    constructor(game: Phaser.Game, group: Phaser.Group){
        this.game = game;
        this.group = group;

        this.undoButton = new DashButton(this.game, this.group, 400, 556, 72, "undo-button", i18n._("Undo"), 400, 508, 0.5);
        this.restartButton = new DashButton(this.game, this.group, 344, 570, 40, "restart", i18n._("Restart"), 364, 535, 1);
        this.menuButton = new DashButton(this.game, this.group, 456, 570, 40, "menu", i18n._("Menu"), 436, 535, 0);

    }
}

class DashButton {
    game: Phaser.Game;
    group: Phaser.Group;
    radius: number;
    button: Phaser.Button;
    label: Phaser.BitmapText | Phaser.Text;
    buttonTween: Phaser.Tween;
    textTween: Phaser.Tween;
    callback: Function;

    constructor(game: Phaser.Game, group: Phaser.Group, x: number, y: number, radius: number, image: string, text: string, tx: number, ty: number, align: number){
        this.game = game;
        this.group = group;
        this.radius = radius;

        this.button = this.game.add.button(x, y, image, () => {
            if (this.callback) this.callback();
        }, this, 1, 0, 2, 1, this.group);
        this.button.anchor.setTo(0.5, 0.5)
        this.button.width = radius;
        this.button.height = radius;
        this.button.alpha = 1;

        this.label = i18n.label(this.game, tx, ty, text, "font-small", 24);
        this.label.anchor.setTo(align, 0.5);
        this.label.alpha = 0;

        this.button.inputEnabled = true;
        this.button.input.useHandCursor = true;
        this.button.events.onInputOver.add(this.onHover, this);
        this.button.events.onInputOut.add(this.outHover, this);
    }

    addCallback(callback: Function){
        this.callback = callback;
    }

    onHover(){
        if(this.buttonTween != null){
            this.buttonTween.stop();
            this.textTween.stop();
        }
        this.buttonTween =  this.game.add.tween(this.button).to( { width: this.radius*1.08, height: this.radius*1.08, alpha: 1 }, 100, "Linear", true);
        this.textTween =  this.game.add.tween(this.label).to( { alpha: 1 }, 100, "Linear", true);
    }

    outHover(){
        if(this.buttonTween != null){
            this.buttonTween.stop();
            this.textTween.stop();
        }
        this.buttonTween =  this.game.add.tween(this.button).to( { width: this.radius, height: this.radius, alpha: 1 }, 100, "Linear", true);
        this.textTween =  this.game.add.tween(this.label).to( { alpha: 0 }, 100, "Linear", true);
    }
}



// WEBPACK FOOTER //
// ./src/dashboard.ts